import apiService from './api-service';
import { utilsService } from "./utils-service";

export const taxReportService = {
	getTaxReport,
	getTaxReports,
	createTaxReport
};

async function getTaxReport() {
	const taxReport = await apiService.get('taxreport/getTaxReport');

	return taxReport;
}

async function getTaxReports(beginDateTime, endDateTime) {
	const options = [
		{
			name: "beginTime",
			value: utilsService.formatDateTime(beginDateTime, utilsService.DATE_TIME_FORMAT3)
		},
		{
			name: "endTime",
			value: utilsService.formatDateTime(endDateTime, utilsService.DATE_TIME_FORMAT3)
		}
	];

	const taxReports = await apiService.get('taxReport/getTaxReports', options);

	return taxReports;
}

async function createTaxReport(taxReport) {
	const response = await apiService.post('taxreport/createTaxReport', taxReport);

	return response;
}
